import React, { useState } from 'react';
import { XIcon, WhatsAppIcon } from './IconComponents';

const TopBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) return null;

    return (
        <div className="bg-brand-blue dark:bg-zinc-900 text-white px-4 py-2 text-sm md:text-base relative z-50 border-b border-brand-accent/20">
            <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center text-center space-y-2 sm:space-y-0 sm:space-x-4 pr-8">
                <span className="font-medium text-slate-100">
                    💰 <strong className="text-yellow-400 dark:text-yellow-400">Best Offer of the Year:</strong> Save 50% on IMA Fees! Ends <strong className="text-red-400 dark:text-red-400">"March 30th"</strong>.
                </span>
                <a 
                    href="https://wa.me/918328080730" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-[#128C7E] hover:bg-[#075e54] text-white px-3 py-1 rounded-full text-sm font-bold transition-colors"
                >
                    <WhatsAppIcon className="w-4 h-4 mr-1" />
                    Chat on WhatsApp
                </a>
            </div>
            <button 
                onClick={() => setIsVisible(false)}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white p-1"
                aria-label="Close banner"
            >
                <XIcon className="w-5 h-5" />
            </button>
        </div>
    );
};

export default TopBanner;
